import React, { Component } from 'react';
import { Tab, Nav  } from 'react-bootstrap';
import Event from './event';
import BusinessProfile from './businessProfile';
import * as design from "../../resources/constants/design";

export default class Ad extends Component {  
  constructor(props) {
    super(props);
    this.state = {data: props.data};
  }

  // ############################ RENDER ###################################
  // ############################ RENDER ###################################
  setKey = (k) => {
    this.setState({key: k});
  }
  
  // ############################ RENDER ###################################
  // ############################ RENDER ###################################
  render() {
    
    // console.log('########## AD => ', this.props.data);
    return (
        <div className={"popup-modern-card"}>
          
          <Tab.Container 
            id="ad-details" 
            defaultActiveKey={(this.props.data['id_event'] ? "event" : "spot")} 
            className="BRL Wide100" 
            style={{height:'100%', display:'flex', flexDirection: 'column'}}
          >
            <div className="popup-modern-tabs-wrap">
              <Nav variant="pills" className="popup-modern-tabs">
                {this.props.data['id_event'] && (
                  <Nav.Item className="popup-modern-tab-item">
                    <Nav.Link eventKey="event" className="HeaderFont FCGray FS40 Padding10px Capital popup-modern-tab-link">
                      {this.props.data.type}
                    </Nav.Link>
                  </Nav.Item>
                )}

                <Nav.Item className="popup-modern-tab-item">
                  <Nav.Link eventKey="spot" className="HeaderFont FCGray FS40 Padding10px Capital popup-modern-tab-link">
                    {this.props.data.business.companyname}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            
            <div className="popup-modern-content">
              <Tab.Content className="popup-modern-content-body">
                    
                  {this.props.data['id_event'] && (
                    <Tab.Pane eventKey="event" className="popup-modern-pane">
                      <div className="popup-modern-panel">
                        <Event data={this.props.data} style={design.EVENT}></Event>
                      </div>
                    </Tab.Pane>
                  )}

                    <Tab.Pane eventKey="spot" className="popup-modern-pane">
                      <div className="popup-modern-panel">
                        <BusinessProfile data={this.props.data.business} style={design.BUSINESS}></BusinessProfile>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
              </div>
          </Tab.Container>
        </div>  
      );

  }

  
}

